import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessCreateUserPage' })(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      marginBottom: 'var(--ebl-s2) !important',
    },
  },
  title: {
    marginBottom: 'var(--ebl-s3)',
  },
  error: {
    marginTop: 'var(--ebl-s2)',
  },
  successButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'var(--ebl-s1)',
  },
}));
